import {
  PayAmountTypography,
  PayAmountContainer,
  AddInsuranceTypography,
  AddInsuranceContainer,
  HorizontalLine,
  AmountContainer,
  PayAmountDiscountTypography,
  SkeletonTotalPriceText,
  PaymentTotalBannerMain,
} from '../styles/PaymentTotalBanner.styles';
import { useModalRouter } from '@hooks/useModalRouter';
import { getRoute } from '@utils';
import { useOrderAndPaymentInfo } from '../zustand/paymentMethodStore';
import { INSURANCE_EMAILS_ALLOWED } from '@config/environment';
import { useAuth } from '@hooks/useAuth';
import { NEXT_PUBLIC_NO_PRICE_FALLBACK } from '@config/environment';
import { CurrencyFormatter } from '@utils/formatters/CurrencyFormatter';

interface PaymentTotalBannerProps {
  payAmount: number;
  userHasInsurances: boolean;
  quoteLoading: boolean;
}

export const PaymentTotalBanner = ({
  payAmount,
  userHasInsurances,
  quoteLoading,
}: PaymentTotalBannerProps) => {
  const { appUser: user } = useAuth();
  const modalRouter = useModalRouter();

  const isPermittedUser = !INSURANCE_EMAILS_ALLOWED
    ? true
    : INSURANCE_EMAILS_ALLOWED.includes(user?.email ?? '');

  const { ordersTotal: originalAmount } = useOrderAndPaymentInfo();

  const handleCreateInsurance = () => {
    void modalRouter.push(
      getRoute('insuranceIntroduction', {
        from: 'checkout',
        redirect: 'checkoutPaymentMethod',
      }),
    );
  };

  const currencyFormatter = new CurrencyFormatter({
    fallback: NEXT_PUBLIC_NO_PRICE_FALLBACK,
  });

  return (
    <PaymentTotalBannerMain>
      <PayAmountContainer>
        <PayAmountTypography>Total a pagar:</PayAmountTypography>
        <AmountContainer>
          {originalAmount != payAmount && (
            <PayAmountDiscountTypography>
              {currencyFormatter.format(originalAmount)}
            </PayAmountDiscountTypography>
          )}
          {quoteLoading ? (
            <SkeletonTotalPriceText />
          ) : (
            <PayAmountTypography>
              {payAmount == 0 ? '$0' : currencyFormatter.format(payAmount)}
            </PayAmountTypography>
          )}
        </AmountContainer>
      </PayAmountContainer>
    </PaymentTotalBannerMain>
  );
};
